import React from 'react';

import lendingtree from 'Shared/images/lendingtree.png';
import mixt from 'Shared/images/split_mixt_logos.png';
import tyler from 'Shared/images/tyler_logo.png';
import github from 'Shared/images/github.png';
import cordial from 'Shared/images/cordial.png';
import adobe from 'Shared/images/adobe.png';
import impact from 'Shared/images/impact.png';
import hybrid from 'Shared/images/hybrid.png';
import nola from 'Shared/images/nola.png';
import buildops from 'Shared/images/buildops.png';
import repairSmith from 'Shared/images/repair_smith.png';
import dialpad from 'Shared/images/dialpad.png';

import './LandingPageFooter.scss';

function LandingPageFooter() {
  return (
    <div className="landing-page-footer d-flex flex-column w-100">
      <div className="landing-page-footer-title text-center mb-3">Loved by managers and their teams at</div>
      <div className="d-flex align-items-center justify-content-around flex-wrap w-100">
        <div className="landing-page-logo-container">
          <img src={lendingtree} alt={lendingtree} />
        </div>
        <div className="landing-page-logo-container">
          <img className="landing-page-footer-logo--mixt" src={mixt} alt={mixt} />
        </div>
        <div className="landing-page-logo-container">
          <img src={tyler} alt={tyler} />
        </div>
        <div className="landing-page-logo-container">
          <img src={github} alt={github} />
        </div>
        <div className="landing-page-logo-container">
          <img src={cordial} alt={cordial} />
        </div>
        <div className="landing-page-logo-container">
          <img src={adobe} alt={adobe} />
        </div>
        <div className="landing-page-logo-container">
          <img src={impact} alt={impact} />
        </div>
        <div className="landing-page-logo-container">
          <img src={hybrid} alt={hybrid} />
        </div>
        <div className="landing-page-logo-container">
          <img src={nola} alt={nola} />
        </div>
        <div className="landing-page-logo-container">
          <img src={buildops} alt={buildops} />
        </div>
        <div className="landing-page-logo-container">
          <img src={repairSmith} alt={repairSmith} />
        </div>
        <div className="landing-page-logo-container">
          <img src={dialpad} alt={dialpad} />
        </div>
      </div>
    </div>
  );
}

export default LandingPageFooter;
